import { render } from "./CustomSelectedOption.vue?vue&type=template&id=6dedbbf8"
import script from "./CustomSelectedOption.vue?vue&type=script&lang=js"
export * from "./CustomSelectedOption.vue?vue&type=script&lang=js"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__